module.exports = __webpack_public_path__ + "static/media/bulk_couriers_force_close_sample.f06271f2.csv";